import React, { useEffect } from 'react';
import { initPixel } from './utils/pixel';
import { HeroSection } from './components/HeroSection';
import { ProblemSection } from './components/ProblemSection';
import { FailedApproaches } from './components/FailedApproaches';
import { MethodSection } from './components/MethodSection';
import { WhatYouGet } from './components/WhatYouGet';
import { WhoIsFor } from './components/WhoIsFor';
import { HowItWorks } from './components/HowItWorks';
import { ProofSection } from './components/ProofSection';
import { FAQSection } from './components/FAQSection';
import { OfferSection } from './components/OfferSection';
import { Footer } from './components/Footer';
export function App() {
  useEffect(() => {
    initPixel();
  }, []);
  return <div className="w-full min-h-screen bg-cream font-sans" data-id="element-0">
      <HeroSection data-id="element-1" />
      <ProblemSection data-id="element-2" />
      <FailedApproaches data-id="element-3" />
      <MethodSection data-id="element-4" />
      <WhatYouGet data-id="element-5" />
      <WhoIsFor data-id="element-6" />
      <HowItWorks data-id="element-7" />
      <ProofSection data-id="element-8" />
      <FAQSection data-id="element-9" />
      <OfferSection data-id="element-10" />
      <Footer data-id="element-11" />
    </div>;
}